import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

let configured = false;
let placesLibraryPromise: Promise<google.maps.PlacesLibrary> | undefined;
let findCareLibrariesPromise: Promise<{
  maps: google.maps.MapsLibrary;
  places: google.maps.PlacesLibrary;
}> | undefined;

function configureGoogleMaps() {
  if (configured) return;
  const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  if (!key) throw new Error('Google Maps is not configured.');
  setOptions({ key, v: 'weekly' });
  configured = true;
}

export function loadGooglePlacesLibrary() {
  if (!placesLibraryPromise) {
    try {
      configureGoogleMaps();
      placesLibraryPromise = importLibrary('places') as Promise<google.maps.PlacesLibrary>;
    } catch (error) {
      placesLibraryPromise = Promise.reject(error);
    }
  }
  return placesLibraryPromise;
}

export function loadFindCareLibraries() {
  if (!findCareLibrariesPromise) {
    try {
      configureGoogleMaps();
      findCareLibrariesPromise = Promise.all([
        importLibrary('maps') as Promise<google.maps.MapsLibrary>,
        loadGooglePlacesLibrary(),
      ]).then(([maps, places]) => ({ maps, places }));
    } catch (error) {
      findCareLibrariesPromise = Promise.reject(error);
    }
  }
  return findCareLibrariesPromise;
}
